import React from 'react';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import { Icon } from 'semantic-ui-react';

import { Menu } from 'src/components/custom';
import { useAppSelector } from 'src/store';
import {
  selectProgress,
  selectWeekClassTopicSidebar,
} from 'src/store/model/class_topic';
import { Typography } from 'src/components/coreUI/index';
import { MenuData } from 'src/components/custom/Menu/context';
import { PATH } from 'src/constants/app';
import { classByIdSelector } from 'src/store/model/classes';

function Modules() {
  const { class_id, class_topic_content_id, class_topic_id } = useParams<{
    class_id: string;
    class_topic_content_id: string;
    class_topic_id: string;
  }>();
  const weeks = useAppSelector((state) =>
    selectWeekClassTopicSidebar(state, class_id),
  );
  const currentClass = useAppSelector((state) =>
    classByIdSelector(state, class_id!),
  );

  const { progress } = useAppSelector((state) =>
    selectProgress(state, class_id!),
  );

  const { pathname } = useLocation();

  // could be homework, module_quiz, class_topic_id
  const pathName = pathname.split('/')[4];

  const getDefaultOpenKeys = (menu?: MenuData[]) => {
    if (!menu) return [];

    // Find the topic that owns the content
    const topics = menu.filter((topic) => {
      return topic.children?.some(
        (c) =>
          c.key === `${class_topic_id}/${class_topic_content_id || pathName}`,
      );
    });

    return topics.map((c) => c?.key || '');
  };

  return (
    <div className="layout_class_sider_modules">
      {weeks.map((week) => {
        return (
          <React.Fragment key={week.key}>
            <Typography.Header className="text-uppercase mt-0">
              {week.content}
            </Typography.Header>
            <Menu
              openKeys={getDefaultOpenKeys(week.children)}
              activeKeys={[
                `${class_topic_id}/${class_topic_content_id || pathName}`,
              ]}
              menu={week.children}
            />

            {week.is_feedback_enabled && currentClass?.type === 'LAUNCHPAD' && (
              <NavLink
                className="feedback_item custom_accordion_item"
                to={`/${PATH.CLASS}/${class_id}/${week.key}/feedback`}
              >
                {({ isActive }) => (
                  <React.Fragment>
                    <div className="flex-1">
                      <Icon
                        name="comment alternate outline"
                        className="mr-12"
                        color={isActive ? 'purple' : undefined}
                      />
                      <span
                        className={isActive ? 'text-primary' : ''}
                      >{`Feedback`}</span>
                    </div>
                  </React.Fragment>
                )}
              </NavLink>
            )}
          </React.Fragment>
        );
      })}

      {currentClass?.type === 'LAUNCHPAD' && progress === 100 && (
        <NavLink
          className="feedback_item custom_accordion_item mb-0"
          to={`/${PATH.ASSESSMENT}/${class_id}`}
        >
          {({ isActive }) => (
            <React.Fragment>
              <div className="flex-1">
                <Icon
                  name="bookmark outline"
                  className="mr-16"
                  color={isActive ? 'purple' : undefined}
                  style={{ marginLeft: -4 }}
                />
                <span
                  className={isActive ? 'text-primary' : ''}
                >{`Final assessment`}</span>
              </div>
            </React.Fragment>
          )}
        </NavLink>
      )}
    </div>
  );
}

export default Modules;
